import * as React from 'react';
import classnames from 'classnames';
import { isNil } from '@grandvisionhq/utils';
import { ShippingThreshold } from '../components/ShippingThreshold.js';
import { Subtotal } from '../components/Subtotal.js';
import { CartDiscount } from '../components/CartDiscount.js';
import { RemoveVoucherCodeContainer } from '../../VoucherCodes/RemoveVoucherCode/RemoveVoucherCodeContainer.js';
import { PaymentMethodPrice } from '../components/PaymentMethodPrice.js';
import { Shipping } from '../components/Shipping.js';
import { MainTotal } from '../components/MainTotal.js';
import { useCartSlots } from '../../../slots/context.js';

const Regular = ({ className , currency , labels , prices , settings , voucherCodes , freeShippingThreshold , isMiniCart , discountedPrice  })=>{
    const { Slots  } = useCartSlots();
    const showShippingThreshold = (!settings.readOnly || isMiniCart) && !isNil(freeShippingThreshold) && !isNaN(freeShippingThreshold) && freeShippingThreshold > 0 ? true : false;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('cart-totals', className)
    }, showShippingThreshold && /*#__PURE__*/ React.createElement(ShippingThreshold, {
        price: discountedPrice || 0,
        labels: labels,
        freeShippingThreshold: freeShippingThreshold || 0
    }), settings.showSubTotal && /*#__PURE__*/ React.createElement(Subtotal, {
        label: labels.subTotal,
        price: prices.subTotalPrice,
        currency: currency
    }), settings.showTotalDiscount && prices.discountPrice !== 0 && /*#__PURE__*/ React.createElement(CartDiscount, {
        label: labels.totalDiscount,
        price: -prices.discountPrice,
        currency: currency
    }), voucherCodes && voucherCodes.map((code)=>/*#__PURE__*/ React.createElement(RemoveVoucherCodeContainer, {
            key: code,
            voucherCode: code
        })
    ), prices.paymentMethodPrice && /*#__PURE__*/ React.createElement(PaymentMethodPrice, {
        label: labels.paymentMethodPrice,
        price: prices.paymentMethodPrice,
        currency: currency
    }), /*#__PURE__*/ React.createElement(Shipping, {
        labels: labels,
        price: prices.shippingPrice,
        currency: currency
    }), /*#__PURE__*/ React.createElement(MainTotal, {
        label: labels.total,
        price: prices.totalPrice,
        currency: currency
    }), Slots.AfterTotals ? /*#__PURE__*/ React.createElement(Slots.AfterTotals, null) : null);
};

export { Regular };
//# sourceMappingURL=Regular.js.map
